import React, { useEffect, useState } from 'react'
import { monthsOptions, yearsOptions } from '../../../utils/Helper';
import { Dropdown } from 'primereact/dropdown';
import BuildReport from '../../../components/ServiceReports/BuildReport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore";
import { callautopopulate } from '../../../services/callautopop';
import HelpDeskReport from '../../../components/ServiceReports/HelpDeskReport';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

const serviceType = [
    { label: "Build Report", value: "build" },
    { label: "Git Repo Request", value: "git" },
    { label: "VPN Request", value: "vpn" },
    { label: "Jenkins Request", value: "jenkins" },
]

const ServiceReport = () => {
    const date = new Date()
    const initialMonth = String(date.getMonth() + 1).padStart(2, '0');
    const [filterValues, setFilterValues] = useState({ apiCall: true, type: "build", month: initialMonth, year: date?.getFullYear() });
    const [options, setOptions] = useState([]);
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    useEffect(() => {
        callautopopulate("projects").then(res => {
            setOptions({ projects: _.sortBy(_.uniq(res.projects, (item) => item.project_id), "project_name") });
        });
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center my-2 gap-3 px-3">
                <div className="d-flex gap-2 align-items-center flex-grow-1">
                    <h5 className="mb-0 text-nowrap">Service Reports</h5>
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2">
                    {filterValues?.type === "build" && <button title="Download Excel" className="sk-btn sk-btn-primary rounded" onClick={() => setFilterValues((prev) => ({ ...prev, excelDownload: true }))}><FontAwesomeIcon icon="fa-solid fa-download" /></button>}
                    <button
                        className="sk-btn-primary rounded"
                        onClick={() => setFilterValues((prev) => ({ ...prev, apiCall: true }))}
                        title="Refresh"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button
                        className="sk-btn-primary rounded"
                        onClick={() => setShowFiltersDrawer(true)}
                        title="Filters"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                </div>
            </div>
            {
                filterValues?.type === "build" && <BuildReport filterValues={filterValues} setFilterValues={setFilterValues} />
            }
            {
                (filterValues?.type === "vpn" || filterValues?.type === "git" || filterValues?.type === "jenkins") && <HelpDeskReport filterValues={filterValues} setFilterValues={setFilterValues} />
            }

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValues({
                                    ...filterValues,
                                    type: "build",
                                    month: initialMonth,
                                    year: date?.getFullYear(),
                                    projects: [],
                                    isChange: true
                                });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Type Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Type</div>
                                <Dropdown
                                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, type: e.target.value, isChange: true })); }}
                                    onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true })) } }}
                                    options={serviceType}
                                    placeholder="Type"
                                    filter
                                    filterInputAutoFocus
                                    value={filterValues?.type}
                                    optionLabel="label"
                                    className="sk-input-dd w-100"
                                />
                            </div>

                            {/* Core Filters */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Projects</div>
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 12 },
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues} />
                            </div>

                            {/* Month Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Month</div>
                                <Dropdown
                                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, month: e.target.value, isChange: true })); }}
                                    onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true })) } }}
                                    options={monthsOptions}
                                    placeholder="Month"
                                    filter
                                    filterInputAutoFocus
                                    value={filterValues?.month}
                                    optionLabel="label"
                                    className="sk-input-dd w-100"
                                />
                            </div>

                            {/* Year Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Year</div>
                                <Dropdown
                                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, year: e.target.value, isChange: true })); }}
                                    onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true })) } }}
                                    options={yearsOptions}
                                    filter
                                    filterInputAutoFocus
                                    placeholder="Year"
                                    value={filterValues?.year}
                                    optionLabel="label"
                                    className="sk-input-dd w-100"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            setFilterValues((prev) => ({ ...prev, apiCall: true }));
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceReport
